import Header from "../Components/Header";
import InfoBodyHappyPay from "../Components/happypay/InfoBodyHappyPay";


const InfoApple = () => {
    return (
        <div className='h-screen w-full'>
            <Header />
            <InfoBodyHappyPay/>
        </div>
    )
}

export default InfoApple;